var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMailBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1794_6297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1794_6297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 16.6666C2.87435 16.6666 2.48199 16.5034 2.1556 16.177C1.82921 15.8506 1.66602 15.4583 1.66602 14.9999V4.99992C1.66602 4.54159 1.82921 4.14922 2.1556 3.82284C2.48199 3.49645 2.87435 3.33325 3.33268 3.33325H16.666C17.1243 3.33325 17.5167 3.49645 17.8431 3.82284C18.1695 4.14922 18.3327 4.54159 18.3327 4.99992V14.9999C18.3327 15.4583 18.1695 15.8506 17.8431 16.177C17.5167 16.5034 17.1243 16.6666 16.666 16.6666H3.33268ZM9.99935 10.8333L3.33268 6.66659V14.9999H16.666V6.66659L9.99935 10.8333ZM9.99935 9.16659L16.666 4.99992H3.33268L9.99935 9.16659ZM3.33268 6.66659V4.99992V14.9999V6.66659Z",
    fill: "#00BCE7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMailBlue);
export default __webpack_public_path__ + "static/media/ic-mail-blue.4e4ecfd1a70d035a53614f2f0df34d30.svg";
export { ForwardRef as ReactComponent };